// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"21fcb81d","152":"83b3bf25","213":"9bbe7be8","232":"3e43fdf4","245":"4e57be57","317":"0e218fbb","403":"9c14cf60","444":"3d22cec7","462":"fae1d07c","485":"aa9ca321","594":"7b9c61c3","727":"d810e650","811":"08302e9b","976":"27344588"}[chunkId] + ".chunk.js";
};